var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYesOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48.5 15.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 48,
    height: 15,
    fill: "#fff",
    stroke: "#828385",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.25,8.51,15.62,4.15h1.77L19.06,7l1.66-2.82h1.74l-2.64,4.4v2.74H18.25Z",
    fill: "#828385"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.17,9.05c0,.9.48,1.31,1.27,1.31a1.17,1.17,0,0,0,1.12-.67h1.25a2.33,2.33,0,0,1-2.42,1.74,2.53,2.53,0,0,1-2.64-2.72A2.59,2.59,0,0,1,24.39,6C26.15,6,27,7.46,26.9,9.05Zm2.31-.9c-.13-.72-.44-1.1-1.13-1.1a1.12,1.12,0,0,0-1.18,1.1Z",
    fill: "#828385"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.84,9.61c0,.62.53.87,1.09.87s.93-.16.93-.66-.59-.58-1.61-.8c-.82-.18-1.64-.47-1.64-1.38C27.61,6.32,28.75,6,29.86,6s2.17.38,2.28,1.65H30.79c0-.55-.46-.7-1-.7-.32,0-.79.06-.79.48s.8.58,1.61.77,1.64.49,1.64,1.45c0,1.36-1.18,1.8-2.36,1.8S27.55,11,27.49,9.61Z",
    fill: "#828385"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesOutline);
export default __webpack_public_path__ + "static/media/YesOutline.52d86d1716de8cde1a4bc1d8f9a28f16.svg";
export { ForwardRef as ReactComponent };